export default __webpack_public_path__ + "static/woman-a490eccbd563afc51e70e4a63806d11d.webp";